<template>
  <div class="tag-data">
    <a-spin :spinning="loading">
      <vxe-table
        border
        size="mini"
        :height="height"
        :data="tableData"
        :scroll-y="{gt: 100}"
      >
        <vxe-column field="name" title="标签" min-width="250">
          <template #default="{ row }">
            <div :style="`paddingLeft:${((row.level - 1) * 20)}px;white-space:normal; word-break:break-all;height: auto;`">{{row.name}}</div>
          </template>
        </vxe-column>
        <vxe-column field="isBaseTag" title="是否基础标签" min-width="100">
          <template #default="{ row }">
            <span v-if="row.isBaseTag">是</span>
            <span v-else>否</span>
          </template>
        </vxe-column>
        <vxe-column field="description" title="说明" min-width="100" />
        <vxe-column field="number" title="number" min-width="100" />
      </vxe-table>
    </a-spin>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      tableData: [],
      height: 'auto'
    }
  },
  methods: {
    setHeight(innerHeight) {
      this.height = innerHeight - 150
    },
    refreshTagList(data) {
      this.height = window.innerHeight - 150
      this.loading = true
      this.tableData = []
      setTimeout(() => {
        this.tableData = data
        this.loading = false
      }, 100)
    }
  }
}
</script>

<style scoped lang='less'>
.tag-data{
  /deep/.vxe-table--render-default.size--mini .vxe-body--column.col--ellipsis>.vxe-cell, .vxe-table--render-default.size--mini .vxe-footer--column.col--ellipsis>.vxe-cell, .vxe-table--render-default.size--mini .vxe-header--column.col--ellipsis>.vxe-cell{
    max-height: none!important;
  }
}
</style>
